<!-- eslint-disable prettier/prettier -->
<template>
  <metainfo>
    <template v-slot:title="{ content }">{{ content }}</template>
    <template v-slot:description="{ content }">{{ content }}</template>
  </metainfo>
    <router-view/>
    <footer-item/>
</template>

<script>
import FooterItem from "@/components/Footer.vue";
export default {
  name: "app",
  components: {
    FooterItem,
  },
  metaInfo() {
    return {};
  },
};
</script>
